import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {AccountsProvider, useAccounts} from "./Accounts.tsx";
import {useEffect, useState} from "react";
import {EventerConsoleNavigation} from "../../../EventerConsoleNavigation.tsx";

interface AccountsGuardProps {
    newAccountPath: string;
}

function InnerAccountsGuard({newAccountPath}: AccountsGuardProps) {

    const location = useLocation()
    const navigate = useNavigate()

    const {accounts} = useAccounts()
    const {accountId} = useParams()

    const [valid, setValid] = useState<Boolean>(false)

    useEffect(() => {

        if (accounts === undefined) {
            // loading ...
            return
        }

        // TODO: error handling?

        const path = location.pathname.trim()
        if (accounts.length === 0) {
            console.info("No accounts found ==> redirect to new account page")
            if (path != newAccountPath && path != `${newAccountPath}/`) {
                window.location.replace(newAccountPath)
                return
            }
        }

        const accountsPath = EventerConsoleNavigation.accounts.path
        if (path == accountsPath || path == `${accountsPath}/`) {

            // We are at "/accounts" without being on a subroute, route to "/accounts/:id"
            let accountId = accounts[0].id

            // Check for a default account in localStorage
            const defaultAccountId = localStorage.getItem("defaultAccountId")
            if (defaultAccountId) {
                if (defaultAccountId !== accountId) {
                    if (accounts.find(account => account.id === defaultAccountId)) {
                        accountId = defaultAccountId
                    } else {
                        localStorage.removeItem("defaultAccountId")
                    }
                }
            }

            console.log("We are at '/accounts' without being on a subroute, route to account: ", accountId)
            EventerConsoleNavigation.accounts.account(accountId).navigate(navigate, location, true)
            return
        }

        // Check if we have a valid account
        if (accountId) {
            let account = accounts.find(account => account.id === accountId)
            if (!account) {
                // TODO: not-found page for account?
                console.info(`Invalid accountId: '${accountId}'`)
                EventerConsoleNavigation.accounts.navigate(navigate, location, true)
                return
            }

            // update the default account (if needed)
            const defaultAccountId = localStorage.getItem("defaultAccountId")
            if (defaultAccountId !== accountId) {
                localStorage.setItem("defaultAccountId", accountId)
            }
        }

        // All checks passed, enable outlet
        setValid(true)

    }, [accounts, location.pathname, navigate, accountId, setValid])

    if (valid) {
        return <Outlet/>
    }
}

export default function AccountsGuard({newAccountPath}: AccountsGuardProps) {
    return (
        <AccountsProvider>
            <InnerAccountsGuard newAccountPath={newAccountPath}/>
        </AccountsProvider>
    )
}
